import './VerifyEmail.scss';
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from 'axios';
import AuthContext from '../../context/AuthContext';
import { API_BASE_URL } from '../../config';

export default function VerifyEmail() {

    const [params] = useSearchParams();
    const token = params.get('token');
    const { acceptTokens } = useContext(AuthContext);
    const navigate = useNavigate();
    const [state, setState] = useState({ status: 'loading', message: '' });
    const ranRef = useRef(false);

    useEffect(() => {
        if (ranRef.current) return;
        ranRef.current = true;

        if (!token) {
            setState({ status: 'error', message: 'الرابط ناقص — لا يوجد رمز تحقق.' });
            return;
        }

        (async () => {
            try {
                const r = await axios.post(`${API_BASE_URL}/api/users/verify-email/`, { token });
                if (r.data?.access && r.data?.refresh) {
                    acceptTokens({ access: r.data.access, refresh: r.data.refresh });
                }
                setState({ status: 'success', message: r.data?.detail || 'تم التفعيل بنجاح' });
                setTimeout(() => navigate('/profile?welcome=1'), 1200);
            } catch (err) {
                setState({
                    status: 'error',
                    message: err.response?.data?.detail || 'تعذر التحقق من بريدك',
                });
            }
        })();
    }, [token, acceptTokens, navigate]);

    return (
        <div className='verify-bg'>
            <div className='verify-card'>
                {state.status === 'loading' && (
                    <>
                        <h1>جارٍ التحقق…</h1>
                        <p>الرجاء الانتظار قليلًا.</p>
                    </>
                )}
                {state.status === 'success' && (
                    <>
                        <div className='verify-tick'>✓</div>
                        <h1>تم تفعيل حسابك</h1>
                        <p>{state.message}</p>
                        <p className='verify-redirect'>سيتم تحويلك تلقائيًا…</p>
                    </>
                )}
                {state.status === 'error' && (
                    <>
                        <h1>تعذر التحقق</h1>
                        <p>{state.message}</p>
                        <Link to='/' className='verify-home'>العودة للصفحة الرئيسية</Link>
                    </>
                )}
            </div>
        </div>
    );
}
